if (document.getElementById("reasons_to_trust")) {
    var summary_buttons = document.querySelectorAll(
        "#reasons_to_trust summary"
    );

    summary_buttons.forEach(function (summary) {
        summary.addEventListener("click", toggleDetails);
    });

    function toggleDetails(event) {
        event.preventDefault();
        target = event.target;
        target_parent = target.parentNode;
        target_span = target.querySelector("span");

        var is_open = target_parent.hasAttribute("open");
        document
            .querySelectorAll("#reasons_to_trust details[open]")
            .forEach(function (el) {
                el.removeAttribute("open");
                el.querySelector("span").classList.add("fa-plus-circle");
                el.querySelector("span").classList.remove("fa-times-circle");
                target.title = "Click to learn more...";
            });
        if (is_open) {
            target_parent.open = false;
            target_span.classList.add("fa-plus-circle");
            target_span.classList.remove("fa-times-circle");
        } else {
            target.title = "Click to close";
            target_span.classList.remove("fa-plus-circle");
            target_span.classList.add("fa-times-circle");
            target_parent.open = true;
        }
    }
}